import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getDynamicLocalCnEnText } from '@/pages/dashboard/utils/utils';
import React, { useEffect, useRef, useState } from 'react';
import { getLocale, useIntl } from 'umi';
import { FilterTitleProps } from '../types';

import './index.scss';

export const FilterTitle = (props: FilterTitleProps) => {
  const {
    originFormValue = {},
    formValue = {},
    gameCode,
    changeFormValue,
  } = props;
  const { locale, getLocalText } = useLocal('filter');
  const { formatMessage } = useIntl();
  const regionInnerHtml =
    document.getElementById('region-input')?.innerHTML || '';
  const [regionValue, setRegionValue] = useState(regionInnerHtml);
  const timeList = [
    'rangeTime',
    'singleTime',
    'contrastDay',
    'statisticDate',
    'contrastDate',
  ];
  const dimensionList = ['zone', 'region', 'channel', 'system', 'language'];
  const inputList = [...timeList, ...dimensionList];
  const showList = inputList?.filter((v) =>
    Object.keys(originFormValue)?.includes(v),
  );

  useEffect(() => {
    // 只有formvalue改变的时候才进行重新赋值
    if (
      JSON.stringify(changeFormValue['region']) !==
        JSON.stringify(formValue['region']) ||
      !regionInnerHtml
    )
      return;
    setRegionValue(regionInnerHtml);
  }, [
    JSON.stringify(formValue),
    JSON.stringify(changeFormValue),
    regionInnerHtml,
  ]);

  const renderValue = (type: string) => {
    if (JSON.stringify(formValue) === '{}') return null;
    if (
      type === 'rangeTime' ||
      type === 'statisticDate' ||
      type === 'contrastDate'
    )
      return Array.isArray(formValue[type])
        ? formValue[type][0] + '~' + formValue[type][1]
        : null;
    if (type === 'singleTime' || type === 'contrastDay')
      return formValue[type] || null;
    if (dimensionList?.includes(type))
      return formatValue(type, formValue[type]);
    return null;
  };

  const formatValue = (type: any, value: string[] | null) => {
    if (value === null) return null;
    if (value[0] === '255') {
      return getLocalText(
        `selector_multiple_component_${type}_all_describe`,
        {},
        false,
      );
    } else {
      if (value?.length > 2) return value?.length;
      return value
        ?.map((item: any) =>
          getDynamicLocalCnEnText(type, item, gameCode, getLocale())?.replace?.(
            /<[^>]+>/gim,
            '',
          ),
        )
        ?.toString?.();
    }
  };

  const renderTitle = (type: string) => {
    if (type === 'rangeTime' || type === 'singleTime') return null;
    if (type === 'contrastDay')
      return (
        <span className="dbd-filter-content-title-item-name">
          {formatMessage({ id: 'contrast day' })}
        </span>
      );
    if (type === 'statisticDate')
      return (
        <span className="dbd-filter-content-title-item-name">
          {formatMessage({
            id: 'comparison_analysis_date_comparison_statistics_date',
          })}
        </span>
      );
    if (type === 'contrastDate')
      return (
        <span className="dbd-filter-content-title-item-name">
          {formatMessage({
            id: 'comparison_analysis_date_comparison_contrast_date',
          })}
        </span>
      );
    return (
      <span className="dbd-filter-content-title-item-name">
        {getLocalText(`selector_multiple_component_${type}_label`, {}, false)}
      </span>
    );
  };

  return (
    <div className="dbd-filter-content-title">
      <div className="dbd-filter-content-title-item">
        <span className="dbd-filter-content-title-item-name">My Filter</span>
      </div>
      {showList?.map((type) => {
        if (type === 'region')
          return (
            formValue[type] && (
              <div
                key={type}
                className="dbd-filter-content-title-item"
                dangerouslySetInnerHTML={{ __html: regionValue }}
              />
            )
          );
        if (renderValue(type) === null) return null;
        return (
          <div className="dbd-filter-content-title-item" key={type}>
            {renderTitle(type)}
            {renderValue(type)}
          </div>
        );
      })}
      <div className="dbd-filter-content-title-button">
        {getLocalText(`show_message`)}
        <div className="dbd-filter-content-title-button-down" />
      </div>
    </div>
  );
};
